import Scoreboard from "./Scoreboard"

Scoreboard.defaultProps = {
  colors: {
    highlight: "#EC8B1C",
    leaderboard: "#1fa2d8",
    primaryFont: "#FFFFFF",
    secondary: "#FFFFFF",
    variables: ""
  },
  entries: [
    { name: "Kidney", score: 12345 },
    { name: "Lima", score: 2345 },
    { isHighlighted: true, name: "Baked", score: 345 },
    { name: "King", score: 45 },
    { name: "Heinz", score: 5 },
  ],
  playerCount: 10,
  playerPosition: 3,
  title: "Total Scores",
}

export default Scoreboard